import React from "react";
import { Button, Flex } from "@jsq/ds/core";
import { SubmitButton } from "@jsq/ds/forms";
import { formStepFooterStyles } from "./styles_vanilla.css";
import { FormStepFooterProps } from "./types";

export const FormStepFooter: React.FC<FormStepFooterProps> = ({
  onBack,
  submitDisabled,
  submitText = "Continue",
}) => {
  return (
    <Flex flexDirection="row-reverse" gap={10} className={formStepFooterStyles}>
      <SubmitButton disabled={submitDisabled}>{submitText}</SubmitButton>
      {onBack && (
        <Button onClick={onBack} variant={"neutral"}>
          Back
        </Button>
      )}
    </Flex>
  );
};
